import React from 'react';
import { useTranslation } from 'react-i18next';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver';
import { ThreadsBackground } from './animations/ThreadsBackground';
import { Sparkles } from 'lucide-react';

export const IntroSection = () => {
  const { t } = useTranslation();
  const [ref, isVisible] = useIntersectionObserver({ threshold: 0.2 });

  return (
    <section id="intro-section" className="py-16 sm:py-24 md:py-32 px-4 sm:px-6 bg-black relative overflow-hidden">
      {/* Threads Background */}
      <ThreadsBackground className="opacity-[0.15]" />
      
      <div className="absolute inset-0 bg-gradient-to-b from-black via-transparent to-black"></div>

      <div className="container mx-auto max-w-6xl relative z-10">
        <div
          ref={ref}
          className={`transform transition-all duration-1000 ${
            isVisible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0'
          }`}
        >
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-8 sm:mb-10 md:mb-12 text-white">
            {t('intro.title')}{' '}
            <span className="text-gray-500">
              {t('intro.titleGray')}
            </span>
          </h2>

          <div className="space-y-6 sm:space-y-8 text-base sm:text-lg text-gray-400 leading-relaxed">
            <p>
              {t('intro.paragraph1').split('Digital Performances').map((part, i, arr) => (
                <React.Fragment key={i}>
                  {part}
                  {i < arr.length - 1 && <strong className="text-white">Digital Performances</strong>}
                </React.Fragment>
              ))}
            </p>

            <p>
              {t('intro.paragraph2').split('Digital Performances').map((part, i, arr) => (
                <React.Fragment key={i}>
                  {part}
                  {i < arr.length - 1 && <strong className="text-white">Digital Performances</strong>}
                </React.Fragment>
              ))}
            </p>
          </div>

          <div className="mt-10 sm:mt-12 md:mt-16 relative group">
            <div className="absolute -inset-1 bg-gradient-to-r from-white/20 to-white/5 rounded-none blur opacity-25 group-hover:opacity-50 transition duration-1000"></div>
            <div className="relative p-6 sm:p-8 md:p-10 rounded-none bg-gradient-to-br from-zinc-900/90 to-black/90 border border-white/20 backdrop-blur-sm">
              <div className="flex flex-col sm:flex-row items-start gap-4 mb-4 sm:mb-6">
                <div className="p-3 rounded-none bg-white/10">
                  <Sparkles className="h-6 w-6 sm:h-8 sm:w-8 text-white" />
                </div>
                <div>
                  <p className="text-2xl sm:text-3xl font-bold text-white mb-2">{t('intro.philosophyTitle')}</p>
                  <div className="h-1 w-16 sm:w-20 bg-gradient-to-r from-white to-transparent"></div>
                </div>
              </div>
              <p className="text-lg sm:text-xl text-gray-300 leading-relaxed sm:pl-16">
                {t('intro.philosophyText')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};